import { Injectable } from '@angular/core';
import { DownloadsService as ApiDownloadsService } from '@ducat-pro-wallets/swag-wallet';

import { createApi } from '../utils';

@Injectable({
    providedIn: 'root',
})
export class DownloadsService extends createApi(ApiDownloadsService) {}
